var _rect, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 73,
    rx: 8,
    fill: "url(#paint0_linear_580_115)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.877 44.7617C38.6373 44.7617 39.2539 44.1452 39.2539 43.3848V37.877C39.2539 37.1166 38.6376 36.5 37.877 36.5H35.123C34.3627 36.5 33.7461 37.1163 33.7461 37.877V43.3848C33.7461 44.1451 34.3626 44.7617 35.123 44.7617H37.877Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8691 21.3594H46.1387C46.1387 21.0821 46.1387 19.7051 46.1387 19.9824C46.1387 17.7046 44.2858 15.8516 42.0078 15.8516C41.7089 15.8516 30.5832 15.8516 30.9922 15.8516C28.7143 15.8516 26.8613 17.7045 26.8613 19.9824C26.8613 20.2597 26.8613 21.6367 26.8613 21.3594H17.1309C14.853 21.3594 13 23.2123 13 25.4902C13 28.187 13.3305 30.5486 13.9866 32.5613C14.6428 34.5739 15.6247 36.2376 16.9278 37.5386C19.1206 39.7284 21.9136 40.6367 25.0497 40.6367H30.9922C30.9922 40.3594 30.9922 37.6055 30.9922 37.8828C30.9922 35.605 32.8451 33.752 35.123 33.752C35.4004 33.752 38.1543 33.752 37.877 33.752C40.1548 33.752 42.0078 35.6049 42.0078 37.8828C42.0078 38.1601 42.0078 40.914 42.0078 40.6367H45.0673C47.8084 40.5228 52.292 41.3563 56.0708 37.595C57.3745 36.2974 58.3567 34.6307 59.0132 32.6086C59.6696 30.5865 60 28.2092 60 25.4902C60 23.2124 58.1471 21.3594 55.8691 21.3594ZM29.6152 19.9824C29.6152 19.2227 30.2324 18.6055 30.9922 18.6055H42.0078C42.7675 18.6055 43.3848 19.2226 43.3848 19.9824C43.3848 20.2597 43.3848 21.6367 43.3848 21.3594H29.6152C29.6152 21.0821 29.6152 19.7051 29.6152 19.9824Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1049 43.395H42.0078C42.0078 45.6728 40.1549 47.5258 37.877 47.5258C37.5996 47.5258 34.8457 47.5258 35.123 47.5258C32.8452 47.5258 30.9922 45.6729 30.9922 43.395C30.6776 43.395 24.7217 43.395 25.0617 43.395C21.1343 43.395 17.6847 42.1899 14.982 39.4914C14.2185 38.7292 13.5666 37.871 13 36.9531V55.7875C13 56.5486 13.6159 57.1645 14.377 57.1645H58.623C59.3841 57.1645 60 56.5486 60 55.7875V37.0098C59.4258 37.9416 58.7712 38.7978 58.0139 39.5519C53.669 43.874 49.0419 43.209 45.1049 43.395Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_580_115",
    x1: 2,
    y1: 2.5,
    x2: 71,
    y2: 71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#981A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#124B6A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame1);
export default __webpack_public_path__ + "static/media/Frame1.fada1af691bbfafb537ae736fc350eee.svg";
export { ForwardRef as ReactComponent };